// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/Assets/LandingPage/amalgamate_bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LandingPage {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100vw;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  color: white;
  overflow: hidden;
}

.landingPageContainer {
  display: flex;
  gap: 5vw;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.landingRightSection {
  width: 71%;
  height: 97%;
  /* background-image: url("../../../public/Assets/LandingPage/rightBackgroundImg.png"); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  position: relative;
}

.landingLeftSection {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22.8%;
  height: 100%;
}

.landingLeftSectionContainer {
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
}

.webAmalgamateLogo {
  height: auto;
  width: 95%;
  max-width: 280px;
  max-height: 75px;
}

.leftSectionContentContainer {
  margin-top: 5vh;
  display: flex;
  flex-direction: column;
  gap: 4vh;
  width: 100%;
}

.leftSectionContent {
  display: flex;
  align-items: start;
  gap: 1vw;
}

.textContainer {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}

.contentHeading {
  font-family: "Poppins", sans-serif;
  font-weight: 600px;
  line-height: 32px;
  font-size: 18px;
  margin-bottom: 10px;
}

.contentTexts {
  font-family: "Poppins", sans-serif;
  font-weight: 400px;
  line-height: 32px;
  color: #808080;
  /* white-space: nowrap; */
  font-size: 16px;
}

.lowerSection {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 8vh;
}

.webGetTheAppContainer {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 1vw;
}

.fadingLine1 {
  width: 5vw;
  height: 1px;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #bebebe);
}

.fadingLine2 {
  width: 5vw;
  height: 1px;
  background: linear-gradient(to right, #bebebe, rgba(255, 255, 255, 0));
}

.webGetTheAppText {
  font-family: "Poppins", sans-serif;
  font-weight: 500px;
  font-size: 14px;
  white-space: nowrap;
}

.downloadAppCards {
  margin-top: 3vh;
  cursor: pointer;
}

.downloadAppCardContainer {
  display: flex;
  align-items: center;
  gap: 1vw;
}

.webDownloadAppCard {
  background-color: #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 68px;
  width: 181.2px;
  box-sizing: border-box;
  padding: 0.5vh 0.5vw;
}

.webDownloadAppCardIcon {
  height: 50%;
}

.webDownloadAppCardIcon2 {
  height: 60%;
}

.downloadAppCardTextContainer {
  display: flex;
  align-items: start;
  flex-direction: column;
  margin-left: 10px;
}

.webDownloadAppCardText1 {
  color: black;
  font-family: "Inter", sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
}

.webDownloadAppCardText2 {
  color: black;
  font-family: "Inter", sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
}

.GetStarted {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.getStartedText {
  font-family: "Inter", sans-serif;
  font-size: 32px;
  font-weight: 600;
}

.btnContainer {
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(300px, 31.5vw, 460px) !important;
  height: 54px;
  background-color: #48d1cc;
  border-radius: 12px;
  margin-top: 28px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 16px rgba(72, 209, 204, 0.25);
  box-sizing: border-box;
}

.btnContainer:hover {
  background-color: #5ce3de;
  transform: translateY(-1px);
  box-shadow: 0 6px 22px rgba(72, 209, 204, 0.38);
}

.btnContainer:active {
  transform: translateY(0);
}




.btnText {
  all: unset;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
}

.faceIdContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
}

.faceIdText {
  color: #48D1CC;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  /* 150% */
}

.dividerContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
  margin-bottom: 24px;
}

.divider {
  width: 13.5vw;
  height: 1px;
  background: white;
}

.orText {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
}

.faceIdIcon {
  width: 2.5vw
}

.signUpText1 {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.signUpText2 {
  color: #48D1CC;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

@media (max-width: 1640px) {
  .landingPageContainer {
    gap: 5vw;
  }

  .leftSectionContentContainer {
    margin-top: 4vh;
    gap: 2vh;
  }

  .leftSectionContent {
    gap: 1vw;
  }

  .contentHeading {
    font-weight: 600px;
    line-height: 30px;
    font-size: 17px;
    margin-bottom: 8px;
  }

  .contentTexts {
    font-weight: 400px;
    line-height: 30px;
    color: #808080;
    font-size: 15px;
  }

  .lowerSection {
    margin-top: 5vh;
  }

  .getTheAppContainer {
    gap: 0.8vw;
  }

  .webGetTheAppText {
    font-weight: 500px;
    font-size: 13px;
  }

  .downloadAppCards {
    margin-top: 2.8vh;
  }

  .webDownloadAppCard {
    height: 60px;
    width: 163px;
  }

  .webDownloadAppCardText1 {
    font-size: 12px;
    font-weight: 500;
  }

  .webDownloadAppCardText2 {
    font-size: 16px;
    font-weight: 600;
  }

  .getStartedText {
    font-size: 28px;
  }

  .btnContainer {
    height: 4.8vh;
    margin-top: 25px;
  }

  .faceIdText {
    font-size: 14px;
  }

  .dividerContainer {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .orText {
    font-size: 11px;
  }

  .btnText {
    font-size: 15px;
    line-height: 22px;
  }
  .signUpText1 {
    font-size: 15px;
  }
  
  .signUpText2 {
    font-size: 15px;
  }
}

@media (max-width: 1440px) {
  .landingPageContainer {
    gap: 4.5vw;
  }

  .leftSectionContentContainer {
    margin-top: 3vh;
    gap: 1vh;
    margin-left: 1vw;
  }

  .leftSectionContent {
    gap: 0.8vw;
  }

  .contentHeading {
    font-weight: 500px;
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 6px;
  }

  .contentTexts {
    font-weight: 400px;
    line-height: 28px;
    color: #808080;
    font-size: 14px;
  }

  .lowerSection {
    margin-top: 3.5vh;
  }

  .getTheAppContainer {
    gap: 0.8vw;
  }

  .webGetTheAppText {
    font-weight: 500px;
    font-size: 12px;
  }

  .downloadAppCards {
    margin-top: 2.5vh;
    margin-left: 1vw;
  }

  .webDownloadAppCard {
    height: 55px;
    width: 150px;
  }

  .webDownloadAppCardText1 {
    font-size: 11px;
    font-weight: 500;
  }

  .webDownloadAppCardText2 {
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
  }

  .getStartedText {
    font-size: 26px;
  }

  .btnContainer {
    height: 4.2vh;
    margin-top: 25px;
  }

  .faceIdText {
    font-size: 13px;
  }

  .dividerContainer {
    margin-top: 14px;
    margin-bottom: 14px;
  }

  .orText {
    font-size: 10px;
  }

  .btnText {
    font-size: 14px;
    line-height: 20px;
  }
  .signUpText1 {
    font-size: 14px;
  }
  
  .signUpText2 {
    font-size: 14px;
  }
}

@media (max-width: 1240px) {
  .landingPageContainer {
    gap: 4vw;
  }

  .leftSectionContentContainer {
    margin-top: 2.5vh;
    gap: 1vh;
    margin-left: 1.2vw;
  }

  .leftSectionContent {
    gap: 0.7vw;
  }

  .contentHeading {
    font-weight: 500px;
    line-height: 26px;
    font-size: 15px;
    margin-bottom: 5px;
  }

  .contentTexts {
    font-weight: 400px;
    line-height: 20px;
    color: #808080;
    font-size: 13px;
  }

  .lowerSection {
    margin-top: 3vh;
  }

  .getTheAppContainer {
    gap: 0.7vw;
  }

  .webGetTheAppText {
    font-weight: 500px;
    font-size: 11px;
  }

  .downloadAppCards {
    margin-top: 2.2vh;
    margin-left: 1.2vw;
  }

  .webDownloadAppCard {
    height: 45px;
    width: 120px;
    border-radius: 8px;
  }

  .webDownloadAppCardText1 {
    font-size: 10px;
    font-weight: 500;
  }

  .webDownloadAppCardText2 {
    font-size: 13px;
    font-weight: 600;
  }

  .getStartedText {
    font-size: 24px;
  }

  .btnContainer {
    height: 4.5vh;
    margin-top: 25px;
  }

  .faceIdText {
    font-size: 12px;
  }

  .dividerContainer {
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .orText {
    font-size: 10px;
  }

  .btnText {
    font-size: 12px;
    line-height: 18px;
  }
  .signUpText1 {
    font-size: 13px;
  }
  
  .signUpText2 {
    font-size: 13px;
  }
}

@media (max-width: 1024px) {
  .landingPageContainer {
    gap: 3.5vw;
  }

  .leftSectionContentContainer {
    margin-top: 2vh;
    gap: 0.8vh;
    margin-left: 1.5vw;
  }

  .leftSectionContent {
    gap: 0.6vw;
  }

  .contentHeading {
    font-weight: 500px;
    line-height: 24px;
    font-size: 14px;
    margin-bottom: 4px;
  }

  .contentTexts {
    font-weight: 400px;
    line-height: 18px;
    color: #808080;
    font-size: 12px;
  }

  .lowerSection {
    margin-top: 2.5vh;
  }

  .getTheAppContainer {
    gap: 0.6vw;
  }

  .webGetTheAppText {
    font-weight: 500px;
    font-size: 10px;
  }

  .downloadAppCards {
    margin-top: 2vh;
    margin-left: 1.5vw;
  }

  .webDownloadAppCard {
    height: 45px;
    width: 110px;
    border-radius: 8px;
  }

  .webDownloadAppCardText1 {
    font-size: 9px;
    font-weight: 500;
  }

  .webDownloadAppCardText2 {
    font-size: 12px;
    font-weight: 600;
  }

  .getStartedText {
    font-size: 20px;
  }

  .faceIdText {
    font-size: 10px;
  }
  .dividerContainer {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .orText {
    font-size: 10px;
  }
  .btnText {
    font-size: 10px;
    line-height: 16px;
  }
  .signUpText1 {
    font-size: 12px;
  }
  .signUpText2 {
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .landingLeftSection {
    display: none !important;
  }
  
  .landingRightSection {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 15px !important;
    min-height: 100vh !important;
    box-sizing: border-box !important;
  }
  
  .landingPageContainer {
    gap: 0 !important;
    justify-content: center !important;
    min-height: 100vh !important;
  }
  
  .landingRightSectionContainer {
    flex: 1 1 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% !important;
    padding: 20px 0 !important;
  }
  
  /* Mobile Logo Styles */
  .mobileLogoContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 30px;
    padding-top: 100px;
  }
  
  .mobileAmalgamateLogo {
    height: 50px;
    width: auto;
    margin-bottom: 10px;
  }
  
  /* Mobile GetStarted Content Styles */
  .GetStarted {
    width: 100% !important;
    max-width: 400px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 25px !important;
  }
  
  .getStartedText {
    font-size: 28px !important;
    font-weight: 700 !important;
    text-align: center !important;
    margin-bottom: 10px !important;
  }
  
  .btnContainer {
    
    max-width: 300px !important;
    height: 50px !important;
    margin-top: 0 !important;
    border-radius: 25px !important;
    font-size: 16px !important;
  }
  
  .btnText {
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  
  .dividerContainer {
    width: 100% !important;
    max-width: 300px !important;
    margin: 0 !important;
  }
  
  .divider {
    width: 100% !important;
    height: 1px !important;
  }
  
  .orText {
    font-size: 14px !important;
    padding: 0 20px !important;
  }
  
  .faceIdContainer {
    width: 100% !important;
    max-width: 300px !important;
    height: 50px !important;
    border-radius: 25px !important;
    border: 1px solid #48D1CC !important;
    background: transparent !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 12px !important;
  }
  
  .faceIdText {
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  
  .faceIdIcon {
    width: 24px !important;
    height: 24px !important;
  }
  
  .signUpContainer {
    margin-top: 10px !important;
  }
  
  .signUpText1 {
    font-size: 14px !important;
  }
  
  .signUpText2 {
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  
  /* Mobile Download Section Styles */
  .mobileDownloadSection {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 30px;
    padding-bottom: 20px;
  }
  
  .mobileGetTheAppContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
  }
  
  .mobileFadingLine1 {
    width: 60px;
    height: 1px;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), #bebebe);
  }
  
  .mobileFadingLine2 {
    width: 60px;
    height: 1px;
    background: linear-gradient(to right, #bebebe, rgba(255, 255, 255, 0));
  }
  
  .mobileGetTheAppText {
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #bebebe;
    white-space: nowrap;
  }
  
  .mobileDownloadAppCards {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 15px;
  }
  
  .mobileDownloadAppCardContainer {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .mobileDownloadAppCard {
    background-color: #ffffff;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 55px;
    width: 150px;
    box-sizing: border-box;
    padding: 10px 15px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .mobileDownloadAppCard:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  .mobileDownloadAppCard:active {
    transform: translateY(0);
  }
  
  .mobileDownloadAppCardIcon {
    height: 28px;
    width: auto;
  }
  
  .mobileDownloadAppCardIcon2 {
    height: 32px;
    width: auto;
  }
  
  .mobileDownloadAppCardTextContainer {
    display: flex;
    align-items: start;
    flex-direction: column;
    margin-left: 10px;
  }
  
  .mobileDownloadAppCardText1 {
    color: black;
    font-family: "Inter", sans-serif;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.2;
    white-space: nowrap;
  }
  
  .mobileDownloadAppCardText2 {
    color: black;
    font-family: "Inter", sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }
}

/* Additional mobile styles for better responsiveness */
@media (max-width: 480px) {
  .landingRightSection {
    padding: 10px !important;
  }
  
  .mobileLogoContainer {
    margin-bottom: 20px;
    padding-top: 15px;
  }
  
  .mobileAmalgamateLogo {
    height: 45px;
  }
  
  .GetStarted {
    max-width: 350px !important;
    gap: 20px !important;
  }
  
  .getStartedText {
    font-size: 24px !important;
  }
  
  .btnContainer {
    max-width: 280px !important;
    height: 48px !important;
  }
  
  .dividerContainer {
    max-width: 280px !important;
  }
  
  .faceIdContainer {
    max-width: 280px !important;
    height: 48px !important;
  }
  
  .mobileDownloadAppCard {
    height: 50px;
    width: 140px;
    padding: 8px 12px;
  }
  
  .mobileDownloadAppCardIcon {
    height: 26px;
  }
  
  .mobileDownloadAppCardIcon2 {
    height: 30px;
  }
  
  .mobileDownloadAppCardText1 {
    font-size: 10px;
  }
  
  .mobileDownloadAppCardText2 {
    font-size: 12px;
  }
}

/* Fallback aliases to ensure compatibility */
.signupButtonsContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.signupButton {
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(300px, 31.5vw, 460px) !important;
  height: 54px;
  background-color: #48d1cc;
  border-radius: 12px;
  margin-top: 28px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 16px rgba(72, 209, 204, 0.25);
  box-sizing: border-box;
}

.signupButton:hover {
  background-color: #5ce3de;
  transform: translateY(-1px);
  box-shadow: 0 6px 22px rgba(72, 209, 204, 0.38);
}

.signupButtonText {
  all: unset;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/Components/SignUpGetStarted/SignUpGetStarted.css"],"names":[],"mappings":"AAIA;EACE,yDAA6E;EAC7E,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wFAAwF;EACxF,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sEAAsE;AACxE;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sEAAsE;AACxE;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;;;;AAKA;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;IACjC,yCAAyC;IACzC,8BAA8B;IAC9B,wBAAwB;IACxB,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,kCAAkC;IAClC,4BAA4B;EAC9B;;EAEA;IACE,oBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,8BAA8B;IAC9B,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA,uBAAuB;EACvB;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;;EAEA,qCAAqC;EACrC;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;;IAEE,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,8BAA8B;IAC9B,oCAAoC;IACpC,kCAAkC;IAClC,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,sEAAsE;EACxE;;EAEA;IACE,WAAW;IACX,WAAW;IACX,sEAAsE;EACxE;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n.LandingPage {\n  background-image: url(\"../../../public/Assets/LandingPage/amalgamate_bg.svg\");\n  width: 100vw;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  height: 100vh;\n  color: white;\n  overflow: hidden;\n}\n\n.landingPageContainer {\n  display: flex;\n  gap: 5vw;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.landingRightSection {\n  width: 71%;\n  height: 97%;\n  /* background-image: url(\"../../../public/Assets/LandingPage/rightBackgroundImg.png\"); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  position: relative;\n}\n\n.landingLeftSection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 22.8%;\n  height: 100%;\n}\n\n.landingLeftSectionContainer {\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: start;\n}\n\n.webAmalgamateLogo {\n  height: auto;\n  width: 95%;\n  max-width: 280px;\n  max-height: 75px;\n}\n\n.leftSectionContentContainer {\n  margin-top: 5vh;\n  display: flex;\n  flex-direction: column;\n  gap: 4vh;\n  width: 100%;\n}\n\n.leftSectionContent {\n  display: flex;\n  align-items: start;\n  gap: 1vw;\n}\n\n.textContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: center;\n}\n\n.contentHeading {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600px;\n  line-height: 32px;\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.contentTexts {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400px;\n  line-height: 32px;\n  color: #808080;\n  /* white-space: nowrap; */\n  font-size: 16px;\n}\n\n.lowerSection {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  margin-top: 8vh;\n}\n\n.webGetTheAppContainer {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1vw;\n}\n\n.fadingLine1 {\n  width: 5vw;\n  height: 1px;\n  background: linear-gradient(to right, rgba(255, 255, 255, 0), #bebebe);\n}\n\n.fadingLine2 {\n  width: 5vw;\n  height: 1px;\n  background: linear-gradient(to right, #bebebe, rgba(255, 255, 255, 0));\n}\n\n.webGetTheAppText {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500px;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.downloadAppCards {\n  margin-top: 3vh;\n  cursor: pointer;\n}\n\n.downloadAppCardContainer {\n  display: flex;\n  align-items: center;\n  gap: 1vw;\n}\n\n.webDownloadAppCard {\n  background-color: #ffffff;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 68px;\n  width: 181.2px;\n  box-sizing: border-box;\n  padding: 0.5vh 0.5vw;\n}\n\n.webDownloadAppCardIcon {\n  height: 50%;\n}\n\n.webDownloadAppCardIcon2 {\n  height: 60%;\n}\n\n.downloadAppCardTextContainer {\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n  margin-left: 10px;\n}\n\n.webDownloadAppCardText1 {\n  color: black;\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.webDownloadAppCardText2 {\n  color: black;\n  font-family: \"Inter\", sans-serif;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.GetStarted {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.getStartedText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 32px;\n  font-weight: 600;\n}\n\n.btnContainer {\n  all: unset;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: clamp(300px, 31.5vw, 460px) !important;\n  height: 54px;\n  background-color: #48d1cc;\n  border-radius: 12px;\n  margin-top: 28px;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 16px rgba(72, 209, 204, 0.25);\n  box-sizing: border-box;\n}\n\n.btnContainer:hover {\n  background-color: #5ce3de;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 22px rgba(72, 209, 204, 0.38);\n}\n\n.btnContainer:active {\n  transform: translateY(0);\n}\n\n\n\n\n.btnText {\n  all: unset;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.faceIdContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.faceIdText {\n  color: #48D1CC;\n  text-align: center;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  /* 150% */\n}\n\n.dividerContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n\n.divider {\n  width: 13.5vw;\n  height: 1px;\n  background: white;\n}\n\n.orText {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 12px;\n}\n\n.faceIdIcon {\n  width: 2.5vw\n}\n\n.signUpText1 {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.signUpText2 {\n  color: #48D1CC;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n@media (max-width: 1640px) {\n  .landingPageContainer {\n    gap: 5vw;\n  }\n\n  .leftSectionContentContainer {\n    margin-top: 4vh;\n    gap: 2vh;\n  }\n\n  .leftSectionContent {\n    gap: 1vw;\n  }\n\n  .contentHeading {\n    font-weight: 600px;\n    line-height: 30px;\n    font-size: 17px;\n    margin-bottom: 8px;\n  }\n\n  .contentTexts {\n    font-weight: 400px;\n    line-height: 30px;\n    color: #808080;\n    font-size: 15px;\n  }\n\n  .lowerSection {\n    margin-top: 5vh;\n  }\n\n  .getTheAppContainer {\n    gap: 0.8vw;\n  }\n\n  .webGetTheAppText {\n    font-weight: 500px;\n    font-size: 13px;\n  }\n\n  .downloadAppCards {\n    margin-top: 2.8vh;\n  }\n\n  .webDownloadAppCard {\n    height: 60px;\n    width: 163px;\n  }\n\n  .webDownloadAppCardText1 {\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .webDownloadAppCardText2 {\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  .getStartedText {\n    font-size: 28px;\n  }\n\n  .btnContainer {\n    height: 4.8vh;\n    margin-top: 25px;\n  }\n\n  .faceIdText {\n    font-size: 14px;\n  }\n\n  .dividerContainer {\n    margin-top: 16px;\n    margin-bottom: 16px;\n  }\n\n  .orText {\n    font-size: 11px;\n  }\n\n  .btnText {\n    font-size: 15px;\n    line-height: 22px;\n  }\n  .signUpText1 {\n    font-size: 15px;\n  }\n  \n  .signUpText2 {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 1440px) {\n  .landingPageContainer {\n    gap: 4.5vw;\n  }\n\n  .leftSectionContentContainer {\n    margin-top: 3vh;\n    gap: 1vh;\n    margin-left: 1vw;\n  }\n\n  .leftSectionContent {\n    gap: 0.8vw;\n  }\n\n  .contentHeading {\n    font-weight: 500px;\n    line-height: 28px;\n    font-size: 16px;\n    margin-bottom: 6px;\n  }\n\n  .contentTexts {\n    font-weight: 400px;\n    line-height: 28px;\n    color: #808080;\n    font-size: 14px;\n  }\n\n  .lowerSection {\n    margin-top: 3.5vh;\n  }\n\n  .getTheAppContainer {\n    gap: 0.8vw;\n  }\n\n  .webGetTheAppText {\n    font-weight: 500px;\n    font-size: 12px;\n  }\n\n  .downloadAppCards {\n    margin-top: 2.5vh;\n    margin-left: 1vw;\n  }\n\n  .webDownloadAppCard {\n    height: 55px;\n    width: 150px;\n  }\n\n  .webDownloadAppCardText1 {\n    font-size: 11px;\n    font-weight: 500;\n  }\n\n  .webDownloadAppCardText2 {\n    font-size: 14px;\n    font-weight: 600;\n    border-radius: 8px;\n  }\n\n  .getStartedText {\n    font-size: 26px;\n  }\n\n  .btnContainer {\n    height: 4.2vh;\n    margin-top: 25px;\n  }\n\n  .faceIdText {\n    font-size: 13px;\n  }\n\n  .dividerContainer {\n    margin-top: 14px;\n    margin-bottom: 14px;\n  }\n\n  .orText {\n    font-size: 10px;\n  }\n\n  .btnText {\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .signUpText1 {\n    font-size: 14px;\n  }\n  \n  .signUpText2 {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 1240px) {\n  .landingPageContainer {\n    gap: 4vw;\n  }\n\n  .leftSectionContentContainer {\n    margin-top: 2.5vh;\n    gap: 1vh;\n    margin-left: 1.2vw;\n  }\n\n  .leftSectionContent {\n    gap: 0.7vw;\n  }\n\n  .contentHeading {\n    font-weight: 500px;\n    line-height: 26px;\n    font-size: 15px;\n    margin-bottom: 5px;\n  }\n\n  .contentTexts {\n    font-weight: 400px;\n    line-height: 20px;\n    color: #808080;\n    font-size: 13px;\n  }\n\n  .lowerSection {\n    margin-top: 3vh;\n  }\n\n  .getTheAppContainer {\n    gap: 0.7vw;\n  }\n\n  .webGetTheAppText {\n    font-weight: 500px;\n    font-size: 11px;\n  }\n\n  .downloadAppCards {\n    margin-top: 2.2vh;\n    margin-left: 1.2vw;\n  }\n\n  .webDownloadAppCard {\n    height: 45px;\n    width: 120px;\n    border-radius: 8px;\n  }\n\n  .webDownloadAppCardText1 {\n    font-size: 10px;\n    font-weight: 500;\n  }\n\n  .webDownloadAppCardText2 {\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  .getStartedText {\n    font-size: 24px;\n  }\n\n  .btnContainer {\n    height: 4.5vh;\n    margin-top: 25px;\n  }\n\n  .faceIdText {\n    font-size: 12px;\n  }\n\n  .dividerContainer {\n    margin-top: 12px;\n    margin-bottom: 12px;\n  }\n\n  .orText {\n    font-size: 10px;\n  }\n\n  .btnText {\n    font-size: 12px;\n    line-height: 18px;\n  }\n  .signUpText1 {\n    font-size: 13px;\n  }\n  \n  .signUpText2 {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .landingPageContainer {\n    gap: 3.5vw;\n  }\n\n  .leftSectionContentContainer {\n    margin-top: 2vh;\n    gap: 0.8vh;\n    margin-left: 1.5vw;\n  }\n\n  .leftSectionContent {\n    gap: 0.6vw;\n  }\n\n  .contentHeading {\n    font-weight: 500px;\n    line-height: 24px;\n    font-size: 14px;\n    margin-bottom: 4px;\n  }\n\n  .contentTexts {\n    font-weight: 400px;\n    line-height: 18px;\n    color: #808080;\n    font-size: 12px;\n  }\n\n  .lowerSection {\n    margin-top: 2.5vh;\n  }\n\n  .getTheAppContainer {\n    gap: 0.6vw;\n  }\n\n  .webGetTheAppText {\n    font-weight: 500px;\n    font-size: 10px;\n  }\n\n  .downloadAppCards {\n    margin-top: 2vh;\n    margin-left: 1.5vw;\n  }\n\n  .webDownloadAppCard {\n    height: 45px;\n    width: 110px;\n    border-radius: 8px;\n  }\n\n  .webDownloadAppCardText1 {\n    font-size: 9px;\n    font-weight: 500;\n  }\n\n  .webDownloadAppCardText2 {\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  .getStartedText {\n    font-size: 20px;\n  }\n\n  .faceIdText {\n    font-size: 10px;\n  }\n  .dividerContainer {\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n  .orText {\n    font-size: 10px;\n  }\n  .btnText {\n    font-size: 10px;\n    line-height: 16px;\n  }\n  .signUpText1 {\n    font-size: 12px;\n  }\n  .signUpText2 {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .landingLeftSection {\n    display: none !important;\n  }\n  \n  .landingRightSection {\n    width: 100% !important;\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding: 15px !important;\n    min-height: 100vh !important;\n    box-sizing: border-box !important;\n  }\n  \n  .landingPageContainer {\n    gap: 0 !important;\n    justify-content: center !important;\n    min-height: 100vh !important;\n  }\n  \n  .landingRightSectionContainer {\n    flex: 1 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: center !important;\n    align-items: center !important;\n    width: 100% !important;\n    padding: 20px 0 !important;\n  }\n  \n  /* Mobile Logo Styles */\n  .mobileLogoContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 30px;\n    padding-top: 100px;\n  }\n  \n  .mobileAmalgamateLogo {\n    height: 50px;\n    width: auto;\n    margin-bottom: 10px;\n  }\n  \n  /* Mobile GetStarted Content Styles */\n  .GetStarted {\n    width: 100% !important;\n    max-width: 400px !important;\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    gap: 25px !important;\n  }\n  \n  .getStartedText {\n    font-size: 28px !important;\n    font-weight: 700 !important;\n    text-align: center !important;\n    margin-bottom: 10px !important;\n  }\n  \n  .btnContainer {\n    \n    max-width: 300px !important;\n    height: 50px !important;\n    margin-top: 0 !important;\n    border-radius: 25px !important;\n    font-size: 16px !important;\n  }\n  \n  .btnText {\n    font-size: 16px !important;\n    font-weight: 600 !important;\n  }\n  \n  .dividerContainer {\n    width: 100% !important;\n    max-width: 300px !important;\n    margin: 0 !important;\n  }\n  \n  .divider {\n    width: 100% !important;\n    height: 1px !important;\n  }\n  \n  .orText {\n    font-size: 14px !important;\n    padding: 0 20px !important;\n  }\n  \n  .faceIdContainer {\n    width: 100% !important;\n    max-width: 300px !important;\n    height: 50px !important;\n    border-radius: 25px !important;\n    border: 1px solid #48D1CC !important;\n    background: transparent !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    gap: 12px !important;\n  }\n  \n  .faceIdText {\n    font-size: 16px !important;\n    font-weight: 600 !important;\n  }\n  \n  .faceIdIcon {\n    width: 24px !important;\n    height: 24px !important;\n  }\n  \n  .signUpContainer {\n    margin-top: 10px !important;\n  }\n  \n  .signUpText1 {\n    font-size: 14px !important;\n  }\n  \n  .signUpText2 {\n    font-size: 14px !important;\n    font-weight: 600 !important;\n  }\n  \n  /* Mobile Download Section Styles */\n  .mobileDownloadSection {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    margin-top: 30px;\n    padding-bottom: 20px;\n  }\n  \n  .mobileGetTheAppContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 20px;\n  }\n  \n  .mobileFadingLine1 {\n    width: 60px;\n    height: 1px;\n    background: linear-gradient(to right, rgba(255, 255, 255, 0), #bebebe);\n  }\n  \n  .mobileFadingLine2 {\n    width: 60px;\n    height: 1px;\n    background: linear-gradient(to right, #bebebe, rgba(255, 255, 255, 0));\n  }\n  \n  .mobileGetTheAppText {\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    color: #bebebe;\n    white-space: nowrap;\n  }\n  \n  .mobileDownloadAppCards {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    gap: 15px;\n  }\n  \n  .mobileDownloadAppCardContainer {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  \n  .mobileDownloadAppCard {\n    background-color: #ffffff;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 55px;\n    width: 150px;\n    box-sizing: border-box;\n    padding: 10px 15px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .mobileDownloadAppCard:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n  \n  .mobileDownloadAppCard:active {\n    transform: translateY(0);\n  }\n  \n  .mobileDownloadAppCardIcon {\n    height: 28px;\n    width: auto;\n  }\n  \n  .mobileDownloadAppCardIcon2 {\n    height: 32px;\n    width: auto;\n  }\n  \n  .mobileDownloadAppCardTextContainer {\n    display: flex;\n    align-items: start;\n    flex-direction: column;\n    margin-left: 10px;\n  }\n  \n  .mobileDownloadAppCardText1 {\n    color: black;\n    font-family: \"Inter\", sans-serif;\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 1.2;\n    white-space: nowrap;\n  }\n  \n  .mobileDownloadAppCardText2 {\n    color: black;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.2;\n    white-space: nowrap;\n  }\n}\n\n/* Additional mobile styles for better responsiveness */\n@media (max-width: 480px) {\n  .landingRightSection {\n    padding: 10px !important;\n  }\n  \n  .mobileLogoContainer {\n    margin-bottom: 20px;\n    padding-top: 15px;\n  }\n  \n  .mobileAmalgamateLogo {\n    height: 45px;\n  }\n  \n  .GetStarted {\n    max-width: 350px !important;\n    gap: 20px !important;\n  }\n  \n  .getStartedText {\n    font-size: 24px !important;\n  }\n  \n  .btnContainer {\n    max-width: 280px !important;\n    height: 48px !important;\n  }\n  \n  .dividerContainer {\n    max-width: 280px !important;\n  }\n  \n  .faceIdContainer {\n    max-width: 280px !important;\n    height: 48px !important;\n  }\n  \n  .mobileDownloadAppCard {\n    height: 50px;\n    width: 140px;\n    padding: 8px 12px;\n  }\n  \n  .mobileDownloadAppCardIcon {\n    height: 26px;\n  }\n  \n  .mobileDownloadAppCardIcon2 {\n    height: 30px;\n  }\n  \n  .mobileDownloadAppCardText1 {\n    font-size: 10px;\n  }\n  \n  .mobileDownloadAppCardText2 {\n    font-size: 12px;\n  }\n}\n\n/* Fallback aliases to ensure compatibility */\n.signupButtonsContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.signupButton {\n  all: unset;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: clamp(300px, 31.5vw, 460px) !important;\n  height: 54px;\n  background-color: #48d1cc;\n  border-radius: 12px;\n  margin-top: 28px;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 16px rgba(72, 209, 204, 0.25);\n  box-sizing: border-box;\n}\n\n.signupButton:hover {\n  background-color: #5ce3de;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 22px rgba(72, 209, 204, 0.38);\n}\n\n.signupButtonText {\n  all: unset;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
